import {Checkbox, styled} from '@mui/material';

export const StyledCheckbox = styled(Checkbox)`
	width: 42px;
	margin-top: -20px;
	padding: 9px 0px 0px 9px;
`;
